import React, { useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import { Button, Typography, Box, Chip, Grid, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import SelectParty from "components/party/components/SelectParty";
import {setAddOrderStoryState} from "store/slice/AppSlice";
import {setPharmaorderAddorderModal} from "store/slice/PharmaSlice";
import { canOrderBeCreatedAPI } from "api/OmsOrdermgmtWebServices";
import {setErrMsg, clearErrMsg} from "store/slice/AppSlice";
import { setSelectedProductId, setSelectedCompositiontemplateId } from "store/slice/PharmaSlice";

export default function SelectPartyPage({ onAdd }) {
  const dispatch = useDispatch()
  const { partyList } = useSelector((state) => state.pharmaslice.partyDashboard);
  const [partyId, setPartyId] = useState(null);
  const {partyObj} = useSelector((state) => state.pharmaslice.partyDashboard);
  const { addOrderStory } = useSelector((state) => state.appslice);
  const {errMsg} = useSelector((state) => state.appslice);

  const initiateOrder = () => {
    dispatch(setAddOrderStoryState({
      title: "Add Product to Order",
      description: "Add products to the order for the selected party",
      currentState: "ADD_PRODUCT_TO_ORDER",
    }));
  }

  const closeStory = () => {
    dispatch(setPharmaorderAddorderModal(false));
  }
  const canOrderBeCreatedAPISuccess = (response) => {
    if (response.result) {
      dispatch(setAddOrderStoryState({
        title: "Add Product to Order",
        description: "Add products to the order for the selected party",
        currentState: "ADD_PRODUCT_TO_ORDER",
      }));
      dispatch(setSelectedProductId(-1)); // Reset selected product ID for new order
      dispatch(setSelectedCompositiontemplateId(-1)); // Reset selected composition template ID for new order
    }
  }
  const canOrderBeCreatedAPIFailure = (error) => {
    dispatch(setErrMsg(error));
  };

  

  const handleContinue = () => {
    canOrderBeCreatedAPI({
      partyId: partyObj.id,
    },canOrderBeCreatedAPISuccess, canOrderBeCreatedAPIFailure);
    
    if (partyId !== null) {
      
    }
  }
  return (
    <>
      

      <SelectParty sectionHeight={'58vh'}/>

      <Grid lg={12} xs={12} item sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", mt: 2 }}>
        <Button variant="outlined" color="secondary" onClick={closeStory} sx={{ mr: 2 }}>
          Close
        </Button>
        <Button
          variant="contained"
          onClick={() => handleContinue()}
          disabled={partyObj.id===undefined}
          sx={{
            '&.Mui-disabled': {
              backgroundColor: 'secondary.400',
              color: 'primary.contrastText',
              opacity: 1,
            },
          }}
        >
          Continue
        </Button>
      </Grid>
    </>
  );
}